import React from 'react';
import { MaterialIcons } from "@expo/vector-icons";
import { Image, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { FormattedMessage } from 'react-intl';

import { styles } from './styles';

const PaymentMethods = ({ onMethodSelected }) => {
  return (
    <ScrollView>
      <View style={styles.container}>
        {/* SOMENTE DESCOMENTAR PARA ATIVAR - <TouchableOpacity style={styles.item} onPress={() => onMethodSelected('CreditCard')}>
          <Image style={styles.icon} source={require('../../../assets/imgs/creditCard.png')} resizeMode='contain' />
          <View style={styles.content}>
            <Text style={styles.title}>Cartão de crédito</Text>
            <Text style={styles.description}>Pague com cartão de crédito.</Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={25}
            color="#2C2C2E"
            style={{ alignSelf: 'center' }}
          />
        </TouchableOpacity> */}

        <TouchableOpacity style={[styles.item, {marginBottom: 12}]} onPress={() => onMethodSelected('PIX')}>
          <Image style={styles.icon} source={require('../../../assets/imgs/pix.png')} resizeMode='contain' />
          <View style={styles.content}>
            <Text style={styles.title}><FormattedMessage id='paymentMethods.txtPix'/></Text>
          </View>
        </TouchableOpacity>

        <TouchableOpacity style={styles.item} onPress={() => onMethodSelected('Boleto')}>
          <Image style={[styles.icon, {marginRight:12}]} source={require('../../../assets/imgs/bankSlip.png')} resizeMode='contain' />
          <View style={styles.content}>
            <Text style={styles.title}><FormattedMessage id='paymentMethods.txtBoletoBancario'/></Text>
          </View>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
}

export default PaymentMethods;